import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export default function ProblemSection() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section data-testid="problem-section" ref={ref} className="py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
          <motion.div
            className="md:col-span-5 img-hover-zoom rounded-sm overflow-hidden"
            initial={{ opacity: 0, x: -40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="relative">
              <img
                src="/joe-speaking.jpg"
                alt="Joe Atkinson presenting PwC's AI Strategy at an executive conference"
                className="w-full h-[360px] md:h-[500px] object-cover hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#121418]/60 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5">
                <p className="text-[10px] uppercase tracking-[0.2em] text-[#C4963B] font-semibold mb-1">PwC AI Strategy</p>
                <p className="text-sm text-[#E8E6E1]/70 font-['Cormorant_Garamond'] italic">
                  "Reinvention, Investment and Scale"
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="md:col-span-7"
            initial={{ opacity: 0, x: 40 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="text-xs uppercase tracking-[0.3em] text-[#C4963B] font-semibold mb-6">
              The Challenge
            </p>
            <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl leading-[1.1] mb-8">
              Still navigating the AI landscape with a map from 2015?
            </h2>
            <div className="space-y-5 text-[#E8E6E1]/55 text-base md:text-lg leading-relaxed">
              <p>
                The vendor noise is deafening. Your board is impatient. Your
                risk team is anxious. And your people are reading headlines that
                say AI is coming for their jobs.
              </p>
              <p>
                The old playbook—pilot projects, innovation theater,
                "data-driven" slide decks—won't cut it anymore. You have 10
                pilots and no production. Your risk people are going to kill
                this before it starts.
              </p>
              <p>
                The top 20% of companies that get AI right capture <span className="text-[#C4963B] font-semibold">74% of the returns</span>.
                The rest are left managing change anxiety and justifying
                failed proofs of concept to increasingly skeptical boards.
              </p>
              <p className="text-[#C4963B] font-medium">
                You need a path that is both bold and responsible. You need
                someone who has already walked it at the largest scale on Earth.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
